module.exports = __webpack_public_path__ + "static/media/baseline-calendar_today-24px.4ef06c47.svg";